module.exports = __webpack_public_path__ + "img/cadenas1.8f3c2913.svg";